import { useState, type ImgHTMLAttributes } from 'react';
import { artworkSrcSet } from '@/lib/artwork';

export interface ArtworkProps extends Omit<ImgHTMLAttributes<HTMLImageElement>, 'src' | 'placeholder'> {
  src: string;
  alt: string;
  fill?: boolean;
  priority?: boolean;
  placeholder?: 'blur' | 'empty';
  blurDataURL?: string;
}

export default function Artwork({ src, alt, fill, priority, placeholder, blurDataURL, style, onLoad, ...props }: ArtworkProps) {
  const [loadedSrc, setLoadedSrc] = useState('');
  return <img {...props} src={src} alt={alt} srcSet={artworkSrcSet(src)}
    loading={priority ? 'eager' : props.loading || 'lazy'} fetchPriority={priority ? 'high' : 'auto'} decoding="async"
    style={{
      ...(fill ? { position: 'absolute', inset: 0, width: '100%', height: '100%' } : {}),
      ...(placeholder === 'blur' && blurDataURL && loadedSrc !== src ? { backgroundImage: `url("${blurDataURL}")`, backgroundSize: 'cover', backgroundPosition: 'center' } : {}),
      ...style,
    }}
    onLoad={event => { setLoadedSrc(src); onLoad?.(event); }} />;
}
